import React from "react";
import LayoutDiagram from "./LayoutDiagram";

/**
 * Modal overlay displaying the poster layout reference diagram.
 */
export default function LayoutDiagramModal({ onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 2000 }}>
      {/* backdrop */}
      <div
        style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.5)" }}
        onClick={onClose}
        aria-hidden="true"
      />
      {/* dialog */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          zIndex: 2001,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 8,
            width: "100%",
            maxWidth: 480,
            pointerEvents: "auto",
            maxHeight: "90vh",
            overflow: "auto",
            boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 20px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <span style={{ fontWeight: 600, fontSize: 15 }}>Layout Reference</span>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={onClose}
              aria-label="Close diagram"
            >
              ✕ Close
            </button>
          </div>
          <div style={{ padding: 16 }}>
            <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 12px" }}>
              This diagram shows where each advanced layout setting maps to on the generated poster.
              Hover over the ⓘ icons next to field labels for details.
            </p>
            <LayoutDiagram />
          </div>
        </div>
      </div>
    </div>
  );
}
